<template lang="html">
  <div id="container">
    <div class="">
      <div class="">
        <vx-card title="Datos requeridos" class="">
          <div class="row w-full">
            <div class="col-md-4" >
              <span class="span-placeholder" for="formasEnganche">Banco *</span>
                <v-select :searchable="true" labelSearchPlaceholder="Buscar" class="listaUl" labelNotFound="No hay resultados con:" labelTitle="Seleccione..." :showDefaultOption="true" v-model="banco" :options="bancos"/>
            </div>            
            <div class="col-md-4">
              <span class="span-placeholder" for="formasEnganche">Tipo de Cuenta *</span>
              <v-select labelTitle="Seleccione..." :showDefaultOption="true" v-model="cuenta" :options='TCuenta'></v-select>
            </div>
            <div class="col-md-4">
              <span class="span-placeholder">Número de cuenta</span>
              <input class="vs-input" v-model="numeroCuenta" name="name" type="number"/>
            </div>     
          </div>
         <div class="row w-full">
            <div class="col-md-4">
              <span class="span-placeholder">Número de cliente</span>
              <input class="vs-input" v-model="codigo" name="name" type="number"/>
            </div>

           <div class="col-md-4">
              <span class="span-placeholder">Fecha de contratación</span>
              <input class="vs-input" type="date" v-model="fechaContratacion" name="fechaNacimiento" />
            </div>
          </div>
          <br>
          <button class="btn btn-second" @click="registraCuenta()" :disabled="!validateForm">Guardar cuenta</button>
        </vx-card>
        <vx-card title="" class="">
          <vs-table :data="cuentas" max-items="5"
            pagination
            noDataText="No hay datos para mostrar">
            <template slot="thead">
              <vs-th>
                Tipo de cuenta
              </vs-th>
              <vs-th>
                Fecha de contratación
              </vs-th>
              <vs-th>
                Código de cliente
              </vs-th>
              <vs-th>
                Número de Cuenta
              </vs-th>
              <vs-th>
                Acciones
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].Cuenta" >
                  {{data[indextr].Cuenta}}
                </vs-td>

                <vs-td :data="data[indextr].FechaDeContrato">
                  {{data[indextr].FechaDeContrato}}
                </vs-td>

                <vs-td :data="data[indextr].CodigoCliente">
                  {{data[indextr].CodigoCliente}}
                </vs-td>

                <vs-td :data="data[indextr].NumeroCuenta">
                  {{data[indextr].NumeroCuenta}}
                </vs-td>
                <vs-td>
                  <vs-row vs-w="12" >
                    <vx-tooltip text="Editar cuenta" position="top">
                      <button class="favoritos" @click="editar(data[indextr])">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <g id="vuesax_twotone_edit" data-name="vuesax/twotone/edit" transform="translate(-620 -252)">
                            <g id="edit">
                              <path id="Vector" d="M9,0H7C2,0,0,2,0,7v6c0,5,2,7,7,7h6c5,0,7-2,7-7V11" transform="translate(622 254)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.4"/>
                              <path id="Vector-2" data-name="Vector" d="M8.991,1.271l-7.88,7.88a2.712,2.712,0,0,0-.66,1.32l-.43,3.01a1.424,1.424,0,0,0,1.7,1.7l3.01-.43a2.8,2.8,0,0,0,1.32-.66l7.88-7.88c1.36-1.36,2-2.94,0-4.94S10.351-.089,8.991,1.271Z" transform="translate(627.049 253.749)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                              <path id="Vector-3" data-name="Vector" d="M0,0A7.144,7.144,0,0,0,4.94,4.94" transform="translate(634.91 256.15)" fill="none" stroke="#26558f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.4"/>
                              <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(620 252)" fill="none" opacity="0"/>
                            </g>
                          </g>
                        </svg>
                      </button>
                    </vx-tooltip>
                    <vx-tooltip text="Borrar cuenta" position="top">
                      <button class="favoritos" @click="eliminar(data[indextr].Id)">
                        <svg class="trash">
                                <g id="trash">
                                  <path id="Vector" d="M18,.5C14.67.17,11.32,0,7.98,0A59.068,59.068,0,0,0,2.04.3L0,.5" transform="translate(3 5.48)" fill="none" stroke="#e42613" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                  <path id="Vector-2" data-name="Vector" d="M0,2.97.22,1.66C.38.71.5,0,2.19,0H4.81C6.5,0,6.63.75,6.78,1.67L7,2.97" transform="translate(8.5 2)" fill="none" stroke="#e42613" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.34"/>
                                  <path id="Vector-3" data-name="Vector" d="M13.7,0l-.65,10.07c-.11,1.57-.2,2.79-2.99,2.79H3.64C.85,12.86.76,11.64.65,10.07L0,0" transform="translate(5.15 9.14)" fill="none" stroke="#e42613" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                  <path id="Vector-4" data-name="Vector" d="M0,0H3.33" transform="translate(10.33 16.5)" fill="none" stroke="#e42613" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.34"/>
                                  <path id="Vector-5" data-name="Vector" d="M0,0H5" transform="translate(9.5 12.5)" fill="none" stroke="#e42613" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" opacity="0.34"/>
                                  <path id="Vector-6" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0"/>
                                </g>
                              </svg>
                      </button>
                    </vx-tooltip>
                  </vs-row>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <vs-popup fullscreen title="Editar cuenta" :active.sync="popupActive">
      <vx-card title="Datos requeridos" class="PopUp">
        <div class="row w-full">
          <div class="col-md-3">
              <span class="span-placeholder" for="formasEnganche">Banco *</span>
              <v-select :searchable="true" class="listaUl" labelSearchPlaceholder="Buscar" labelNotFound="No hay resultados con:" labelTitle="Seleccione..." :showDefaultOption="true" v-model="banco" :options="bancos"/>             
          </div>
          <div class="col-md-3">
            <span class="span-placeholder" for="formasEnganche">Tipo de Cuenta *</span>
            <v-select labelTitle="Seleccione..." :showDefaultOption="true" v-model="cuenta" :options='TCuenta'></v-select>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número de cuenta</span>
            <input class="vs-input" v-model="numeroCuenta" name="name" type="number"/>
          </div>
          <div class="col-md-3">
            <span class="span-placeholder">Número de cliente</span>
            <input class="vs-input" v-model="codigo" name="name" type="number"/>
          </div>
        </div>
        <div class="row w-full">
          <div class="col-md-3">
            <span class="span-placeholder">Fecha de contratación</span>
            <input class="vs-input" type="date" v-model="fechaContratacion" name="fechaNacimiento" />
          </div>
        </div>
        <br>
        <vs-button color="primary" @click="editarCuenta()" :disabled="!validateForm">Editar cuenta</vs-button>
      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from '@alfsnd/vue-bootstrap-select'

export default {
  components: {
    vSelect

  },
  data(){
		return{
      popupActive: false,
      cuentaId:'',
      fechaContratacion:'',
      numeroCuenta:'',
      codigo:'',
      cuenta:'',
      cuentas:[],
      tiposDeCuentas:[],
      email:'',
      key:'',
      id:'',
      banco:'',
     bancos: [
				{ text: 'ACTINVER', value: 'ACTINVER' },
				{ text: 'AFIRME', value: 'AFIRME' },
        { text: 'AMERICAN EXPRESS', value: 'AMERICAN EXPRESS' },
        { text: 'AUTOFIN', value: 'AUTOFIN' },
        { text: 'AZTECA', value: 'AZTECA' },
        { text: 'BBVA', value: 'BBVA' },
        { text: 'BAJIO', value: 'BAJIO' },
        { text: 'BANCOMEXT', value: 'BANCOMEXT' },
        { text: 'BANCO FAMSA', value: 'BANCO FAMSA' },
        { text: 'BANOBRAS', value: 'BANOBRAS' },
        { text: 'BANORTE', value: 'BANORTE' },
        { text: 'BANREGIO', value: 'BANREGIO' },
        { text: 'BANCOPPEL', value: 'BANCOPPEL' },
        { text: 'BMULTIVA', value: 'BMULTIVA' },
        { text: 'CITIBANAMEX', value: 'CITIBANAMEX' },
        { text: 'COMPARTAMOS', value: 'COMPARTAMOS' },
        { text: 'GBM', value: 'GBM' },
        { text: 'HSBC', value: 'HSBC' },
        { text: 'INBURSA', value: 'INBURSA' },
        { text: 'INTERBANCO', value: 'INTERBANCO' },
        { text: 'IXE', value: 'IXE' },
        { text: 'MIFEL', value: 'MIFEL' },
        { text: 'SANTANDER', value: 'SANTANDER' },
        { text: 'SCOTIABANK', value: 'SCOTIABANK' },
        { text: 'STP', value: 'STP' },
        { text: 'VE POR MAS', value: 'VE POR MAS' },
        { text: 'WAL-MART', value: 'WAL-MART' },
			],
      TCuenta:[
        { text: 'AHORRO', value: '43' },
				{ text: 'CREDITO', value: '44' },
        { text: 'DEBITO', value: '45' },
        { text: 'INVERSIONES', value: '46' },
        { text: 'NOMINA', value: '47' },
      ],
      selectedValue: null
    }
  },
  computed:{
    validateForm(){
      // return this.numeroCuenta != '' && this.fechaContratacion != '' && this.cuenta != ''
      return this.banco != '' && this.cuenta != '';
    }
  },
  watch: {
    popupActive:function(){
      if (this.popupActive == false) {
        this.limpiaForm()
      }
    },
  },
  mounted(){
    this.id=this.$route.params.id
    this.getApikey()
    this.getListaCuentas()
    this.dameCaso()
  },
  methods:{
    editarCuenta(){
      let self= this
      var objRequestRegistraCuentasBancarias = {
        strFolioCaso: this.id,
        strApiKey:this.key,
        strMetodo:'EditarCuentasBancarias',
        objSolicitante:{
            EMail:this.email,
            CuentasBancarias:[
              {
                Id:this.cuentaId,
                Banco:this.banco.value,
                Cuenta:this.cuenta.value,
                CodigoCliente:this.codigo,
                NumeroCuenta : this.numeroCuenta,
                FechaDeContrato : this.fechaContratacion
              }
            ]
        }
      }
      this.$axios.post('/',objRequestRegistraCuentasBancarias,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.$vs.notify({
              title:`Datos editados exitosamente`,
              position:'top-right'
            })
            this.popupActive=false
            this.limpiaForm()
            this.dameSolicitante()
          }else {
            if (response.data.intEstatus == 2249) {
              this.$vs.notify({
                title:'No se puede duplicar el tipo de cuenta',
                color:'danger',
                position:'top-right'
              })
            }else {
              this.$vs.notify({
                title:'Ocurrio un error en RegistraCuentasBancarias',
                text:response.data.strError,
                color:'danger',
                position:'top-right'
              })
            }
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    editar(cuenta){
      // console.log(cuenta)
      this.fechaContratacion= cuenta.FechaDeContrato
      this.banco = cuenta.Banco
      this.numeroCuenta=cuenta.NumeroCuenta
      this.codigo=cuenta.CodigoCliente
      this.cuenta=cuenta.Cuenta
      this.cuentaId=cuenta.Id
      this.popupActive=true
    },
    eliminar(id){
      var eliminarCuentas = {
        strFolioCaso: this.id,
        strApiKey:this.key,
        strMetodo:'BorrarCuentasBancarias',
        objSolicitante:{
            EMail:this.email,
            CuentasBancarias:[
              {
                Id:id
              }
            ]
          }
      }
      this.$axios.post('/',eliminarCuentas,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.$vs.notify({
              title:`Se eliminó exitosamente`,
              position:'top-right'
            })
            this.dameSolicitante()
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en BorrarCuentasBancarias',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    registraCuenta(){
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      })
      let self= this
      var objRequestRegistraCuentasBancarias = {
        strFolioCaso: this.id,
        strApiKey:this.key,
        strMetodo:'RegistraCuentasBancarias',
        objSolicitante:{
            EMail:this.email,
            CuentasBancarias:[
              {
                Banco:this.banco.value,
                Cuenta:this.cuenta.value,
                CodigoCliente:this.codigo,
                NumeroCuenta : this.numeroCuenta,
                FechaDeContrato : this.fechaContratacion
              }
            ]
        }
      }
      this.$axios.post('/',objRequestRegistraCuentasBancarias,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.$vs.notify({
              title:`Datos guardados exitosamente`,
              position:'top-right'
            })
            this.limpiaForm()
            this.dameSolicitante()
            this.$vs.loading.close('#container > .con-vs-loading')
          }else {
            //if (response.data.intEstatus == 2194) {
            if (response.data.strError.indexOf("Duplicate entry")) {
              this.$vs.notify({
                title:'No se puede duplicar el tipo de cuenta',
                color:'danger',
                position:'top-right'
              })
            }else {
              this.$vs.notify({
                title:'Ocurrio un error en RegistraCuentasBancarias',
                text:response.data.strError,
                color:'danger',
                position:'top-right'
              })
            }
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameCaso(){
      let self= this
      var objRequestDameCaso = {
        strApiKey: this.key,
        strMetodo: 'DameCaso',
        objCaso: {
         Id: this.id
        }
      }
      this.$axios.post('/',objRequestDameCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.email= response.data.objContenido.Solicitante
            this.dameSolicitante()
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameCaso',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    dameSolicitante(){
      let self= this
      var objRequestDameSolicitante = {
        strFolioCaso: this.id,
        strApiKey: this.key,
        strMetodo: 'DameSolicitante',
        objSolicitante: {
         EMail: this.email
        }
      }
      this.$axios.post('/',objRequestDameSolicitante,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            this.cuentas=response.data.objContenido.CuentasBancarias
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameSolicitante',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getListaCuentas(){
      let self= this
      var objRequestListaCasoEstatus = {
        strApiKey: this.key,
        strMetodo: 'ListaTipoClientesBancarios',
      }
      this.$axios.post('/',objRequestListaCasoEstatus,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            let aux = response.data.objContenido
            for (const property in aux) {
                  if (aux[property].Estatus == true) {
                    this.tiposDeCuentas.push(aux[property])
                  }
                  // console.log(this.tiposDeCuentas)
              }
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en ListaTipoClientesBancarios',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    limpiaForm(){
      this.fechaContratacion=''
      this.numeroCuenta=''
      this.codigo=''
      this.cuenta=null
      this.banco = null
    },
    getApikey(){
      if(!JSON.parse(localStorage.getItem('userInfo')).ApiKey){
        this.$router.push('/login');
      }else {
        this.key=JSON.parse(localStorage.getItem('userInfo')).ApiKey;
      }
    },
  }
}
</script>

<style lang="css" >
.v-select.listaUl ul {
    height: 236px !important;
    overflow-y: auto !important;
    border: none !important;
}

.v-select-toggle {
    background-color: #fff !important;
    border: 1px solid #dae0e5 !important;
    height: 31px;
}
.v-dropdown-container[data-v-138dff1d] {
  z-index: 888;
}

.v-select{
  width: 100%;
  margin-top: 12px;
  size: 5;
}
.vs-input{
  font-size: 12px;
}
.PopUp{
  margin-bottom: 200px;
}
.label-select{
  margin-top: 3%;
}
</style>
